import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import * as Styled from './CouponDialogInitIal.styled';
import { ButtonLink, Logo } from '../../CouponDialog.styled';
import { trackEvent } from '../../../../util/track';

/**
 * CouponDialogInitial displays a yes/no button as a first step of CouponDialog before CouponDialogForm is shown
 */
const CouponDialogInitial = ({
  onComplete,
  onReject,
  isAutoApplied,
  discountPercentage
}) => {
  useEffect(() => {
    trackEvent({ event: 'Coupon Dialog Micro Yes View' })
  }, []);

  return (
  <Styled.CouponDialogInitial>
    <Logo />
    <Styled.Heading>
      Want {discountPercentage}% Off
      {isAutoApplied ? (
        '?'
      ) : (
        <>
          <br />
          Your First Order?
        </>
      )}
    </Styled.Heading>
    <Styled.ButtonContainer>
      <Styled.YesButton
        type="button"
        size="large"
        variant="primary"
        isFull
        onClick={() => {
          trackEvent({ event: 'couponModalMicroYes' });
          onComplete();
        }}
      >
        Yes, Please
      </Styled.YesButton>
      <ButtonLink type="button" onClick={() => {
        trackEvent({ event: 'couponModalContinueShopping' });
        onReject();
        }}>
        No, I&apos;ll Continue Shopping
      </ButtonLink>
    </Styled.ButtonContainer>
  </Styled.CouponDialogInitial>
)};

CouponDialogInitial.propTypes = {
  /**
   * A function that is called to render the CouponDialogForm (stage 2).
   */
  onComplete: PropTypes.func.isRequired,
  /**
   * A function that is called to close the form.
   */
  onReject: PropTypes.func.isRequired,
  /**
   * If `true`, coupon is being auto applied.
   */
  isAutoApplied: PropTypes.bool.isRequired,
  /**
   * Percentage off value of the discount
   */
  discountPercentage: PropTypes.number
};

CouponDialogInitial.defaultProps = {
  discountPercentage: 20
};

export default CouponDialogInitial;
